(function(window, factory) {
    var globalInstall = function(){
        factory(window.lazySizes);
        window.removeEventListener('lazyunveilread', globalInstall, true);
    };

    factory = factory.bind(null, window, window.document);

    if(typeof module == 'object' && module.exports){
        factory(require('lazysizes'));
    } else if(window.lazySizes) {
        globalInstall();
    } else {
        window.addEventListener('lazyunveilread', globalInstall, true);
    }
}(window, function(window, document, lazySizes) {
    document.addEventListener('lazybeforeunveil', function(e) {
        if (e.detail.instance != lazySizes) {
            return;
        }

        e.target.addEventListener('lazyloaded', function(e) {
            e.target.parentNode.classList.add('lazyloaded');
        });
    });
}));
